"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANSICHTEN = void 0;
exports.ansichtSichtbar = ansichtSichtbar;
exports.ANSICHTEN = {
    /** Die eigenen Rechte — Grundlage jeder Sichtbarkeitsentscheidung. */
    sitzung: { laedt: ['session.permissions'], rechte: [] },
    /** Erreichbarkeit über tRPC (AC-010). */
    verbindung: { laedt: ['system.ping'], rechte: [] },
    /** Nutzerverwaltung (AC-107). */
    nutzerverwaltung: { laedt: ['principals.list', 'tenant.settings'], rechte: ['principals:read'] },
};
function ansichtSichtbar(name, rechte) {
    const ansicht = exports.ANSICHTEN[name];
    return ansicht.rechte.every((recht) => rechte.has(recht));
}
//# sourceMappingURL=ansichten.js.map